import React from 'react';

import AdminDictionaryList, { Pair } from '@dashboard/components/AdminDictionaryList';
import { usePlatformCountsQuery } from '@dashboard/generated/wp/administrator';

type Props = {
  platformId: string;
};
export default function SesConfiguration({ platformId }: Props) {
  const { data } = usePlatformCountsQuery({ variables: { id: platformId } });
  const config = data?.Platform.sesConfiguration;

  return (
    <AdminDictionaryList>
      <Pair label="Name" value={config?.name} />
      <Pair label="IP Pool" value={config?.ipPoolName} />
      <Pair label="Click" value={config?.clickEvent} />
      <Pair label="Open" value={config?.openEvent} />
    </AdminDictionaryList>
  );
}
